import type {
  GameRowCollection,
  IndexGameQuery,
} from '../../backend.d'
import {
  IndexGameQuerySchema,
} from '../../backend_schemas'
import { createResource, type Accessor } from 'solid-js'
import { parse, safeParse } from 'valibot'
import { backendAxios } from '../../axios'
import { StateSchema } from '../../lib/core/state/State.type'
import { gameDisk } from '../../lib/core/disk/IndexedDBDisk'
import { StateMapDisk } from '../../lib/core/state/state_map_disk.enum'
import { isOfflineOnly } from '../../lib/core/isOfflineOnly'
import { hasIndexedDB } from '../../lib/core/Storage/IndexedDB/hasIndexedDB'

export interface ExtendedIndexGameQuery extends IndexGameQuery {
  disk?: StateMapDisk
}

async function fetchGameCollectionByQuery(inputParams: ExtendedIndexGameQuery): Promise<GameRowCollection> {
  const disk = inputParams.disk || StateMapDisk.Cloud
  const result = safeParse(IndexGameQuerySchema, inputParams)

  if (result.success) {
    const params = result.output
    let collection: GameRowCollection = []

    if (disk === StateMapDisk.IndexedDB) {
      if (!hasIndexedDB()) {
        throw new Error('IndexedDB requested but not available')
      }
      collection = await gameDisk.list()
    } else if (disk === StateMapDisk.Cloud && !isOfflineOnly && import.meta.env.VITE_HONO_URL) {
      try {
        const response = await backendAxios.get(`/st1/game`, { params })
        collection = response.data as GameRowCollection
      } catch (e) {
        console.error('Failed to fetch from cloud', e)
      }
    } else {
      throw new Error('Invalid disk: ' + disk)
    }

    collection.forEach((row): void => {
      row.data = parse(StateSchema, row.data)
    })
    return collection
  }
  return []
}

export default function createGameCollectionResource(
  getInputQuery: Accessor<Partial<ExtendedIndexGameQuery>>
) {
  const resource = createResource(getInputQuery, fetchGameCollectionByQuery)
  return resource
}
